import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import { CancelButton, SaveAndUpdate } from "../../utils/commonComponent/Custom/Button";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { Autocomplete, TextField } from "@mui/material";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";

const EditUnitMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate(); 
  const [inputStates, setInputStates] = React.useState({});
  const [symbolList, setSymbolList] = React.useState([]);
  const [disgroupList, setDisGroupList] = React.useState([]);
  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchDisciplineDetails = async () => {
    try {
      const gropuList = await fetchQuery(`select * from discipline where name = ${inputStates.disciplineId}`);
      setDisGroupList(gropuList);
    } catch (error) {
      console.error("Error fetching Discipline data:", error);
    }
  };

  const fetchUnitDetails = async () => {
    try {
      const [unit] = await fetchQuery(`select * from unit where id = ${params.id}`);
      setInputStates(unit);
    } catch (error) {
      console.error("Error fetching Unit data:", error);
    }
  };

  const getSymbolList = async () => {
    try {
      const unitList = await fetchQuery("select * from predefineSymbols");
      setSymbolList(unitList);
    } catch (err) {
      console.error("Error fetching symbol list:", err);
    }
  };

  const onSubmit = async () => {
    // show alert
    const fieldsToValidate = [
      { value: inputStates.disciplineId, label: "Select Discipline" },
      { value: inputStates.groupId, label: "Group is required" },
      { value: inputStates.symbol, label: "Unit Selection is required" }
    ];
    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }
    try {
      const url = BASE_URL + `unit`;
      params.id != 0
        ? await axiosWithToken.patch(url + `/${params.id}`, inputStates)
        : await axiosWithToken.post(url, inputStates);

      toast.success(
        params.id !== "0"
          ? "Unit Updated Successfully!"
          : "Unit Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/unit"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    getSymbolList();
    if (params.id != 0) {
      fetchUnitDetails();
    }
  }, []);

  useEffect(() => {
    if (inputStates.disciplineId) {
      fetchDisciplineDetails();
    }
  }, [inputStates.disciplineId]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Unit" : "Update Unit"}
      </Text>
      <br />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="col-span-1">
          <Autocomplete
            size="small"
            disabled={params.id != 0}
            id="unit_edit_discipline"
            value={
              DisciplineOptions.find((d) => d.id == inputStates.disciplineId
              ) || null
            }
            options={DisciplineOptions}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField {...params} label="Discipline *" />
            )}
            onChange={(event, newValue) => {
              updateInputObject("disciplineId", newValue ? newValue.id : "");
            }}
          />
        </div>

        <div className="col-span-1">
          <Autocomplete
            size="small"
            id="unit_edit_dgrpup"
            value={
              disgroupList.find((d) => d.id == inputStates.groupId) || null
            }
            options={disgroupList}
            getOptionLabel={(option) => option?.groupName || ""}
            renderInput={(params) => <TextField {...params} label="Group *" />}
            onChange={(event, newValue) => {
              updateInputObject("groupId", newValue ? newValue.id : "");
            }}
          />
        </div>

        <div className="col-span-1">
          <Autocomplete
            size="small"
            id="unit_edit_symbol"
            value={
              symbolList.find((s) => s.symbol === inputStates.symbol) || null
            }
            options={symbolList}
            getOptionLabel={(option) =>
              `${option.symbol || ""} (${option.name || ""})`
            }
            renderInput={(params) => <TextField {...params} label="Symbol *" />}
            onChange={(event, newValue) => {
              updateInputObject("symbol", newValue ? newValue.symbol : "");
            }}
            renderOption={(props, option) => (
              <li {...props}>
                <span
                  style={{
                    color: option?.type === "custom" ? "blue" : "black",
                  }}
                >
                  {option.symbol} ({option.name})
                </span>
              </li>
            )}
          />
        </div>
      </div>
      <br />
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditUnitMaster;
